<template>
  <div class="fullPage">
    <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
      <v-card>
        <form data-vv-scope="cardListForm">
          <v-card-title>
            <div>
              <div class="headline">Credit Card List Information</div>
            </div>
            <v-spacer></v-spacer>
            <div slot="action" v-if="!newCreditCardList">
              <v-tooltip top>
                <v-btn slot="activator" icon @click="doQuery">
                  <v-icon color="primary">mdi-magnify</v-icon>
                </v-btn>
                <span>Query Credit Card List</span>
              </v-tooltip>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <message :messages="messages" v-if="!cardNoDialog"></message>
            <v-container fluid grid-list-lg>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs6 v-if="newCreditCardList">
                    <v-text-field :label="labels.cardListCode" v-model="cardListForm.cardListCode" :error-messages="errors.collect('cardListForm.cardListCode')" v-validate="'required|param|max:20'" data-vv-name="cardListForm.cardListCode" :data-vv-as="labels.cardListCode"></v-text-field>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-subheader class="queryLabel">{{labels.cardListCodeQuery}}</v-subheader>
                    <div class="subheading">{{cardListForm.cardListCode}}</div>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field :label="labels.cardListDesc" v-model="cardListForm.cardListDesc" :error-messages="errors.collect('cardListForm.cardListDesc')" v-validate="'required|entry|max:100'" data-vv-name="cardListForm.cardListDesc" :data-vv-as="labels.cardListDesc"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
        </form>
        <v-divider></v-divider>
        <v-card-title>
          <div>
            <div class="headline">{{labels.cardNoList}}</div>
          </div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="cardNo" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.cardNo }}</td>
            <td class="text-xs-left">{{ props.item.cardDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" review @review="doReview(props)" remove @remove="doRemove"></table-action>
            </td>
          </template>
        </v-data-table>
        <v-dialog v-model="cardNoDialog" max-width="600px" persistent>
          <v-btn slot="activator" color="secondary" dark class="mb-2" @click="doNew">
            Add Card
            <v-icon right>{{ 'mdi-credit-card' }}</v-icon>
          </v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">{{ labels.cardInfo }}</span>
            </v-card-title>
            <v-card-text>
              <message :messages="messages"></message>
              <form data-vv-scope = "cardForm">
                <v-container grid-list-md>
                  <v-layout row wrap>
                      <v-flex xs4 v-if="newCardNo">
                        <v-text-field data-vv-scope = "cardForm" v-model="cardForm.cardNo" :label="labels.cardNo" :error-messages="errors.collect('cardForm.cardNo')" data-vv-name="cardForm.cardNo" :data-vv-as="labels.cardNo" v-validate="'required|param|max:20'"></v-text-field>
                      </v-flex>
                      <v-flex xs4 v-else>
                        <v-subheader class="queryLabel">{{labels.cardNoQuery}}</v-subheader>
                        <div class="subheading">{{cardForm.cardNo}}</div>
                      </v-flex>
                      <v-flex xs8>
                        <v-text-field data-vv-scope = "cardForm" v-model="cardForm.cardDesc" :label="labels.cardDesc" :error-messages="errors.collect('cardForm.cardDesc')" v-validate="'required|entry|max:100'" data-vv-name="cardForm.cardDesc" :data-vv-as="labels.cardDesc"></v-text-field>
                      </v-flex>
                  </v-layout>
                </v-container>
              </form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click.native="doCloseCardDialog">Cancel</v-btn>
              <v-btn color="primary" flat @click.native="doSaveCard">Add</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn color="primary" :loading="submitting" @click.native="doSaveCardList">
          {{newCreditCardList? 'Save Card List' : 'Update Card List'}}
          <v-icon right>{{newCreditCardList? 'mdi-credit-card-multiple' : 'mdi-content-save'}}</v-icon>
        </v-btn>
      </v-card>
    </page>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      breadcrumb: [],
      headers: [
        { text: 'Card Number', value: 'cardNo' },
        { text: 'Card Description', value: 'cardDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        creditCardList: 'Credit Card List Details',
        cardNoList: 'Card Number List',
        cardListCode: 'Card List Code*',
        cardListCodeQuery: 'Card List Code',
        cardListDesc: 'Card List Description*',
        cardInfo: 'Card Information',
        cardNo: 'Card Number*',
        cardNoQuery: 'Card Number',
        cardDesc: 'Card Description*'
      },
      cardListForm: {
        cardListCode: undefined,
        cardListDesc: undefined,
        cardNoList: []
      },
      cardForm: {
        cardNo: undefined,
        cardDesc: undefined
      },
      cardNoIndex: -1,
      newCardNo: false,
      newCreditCardList: false,
      cardNoDialog: false,
      menu: [],
      items: []
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName'
    ]),
    title() {
      if (this.newCreditCardList) {
        return 'New Credit Card List'
      } else {
        return 'Review Credit Card List'
      }
    }
  },
  methods: {
    async doInit() {
      if (!this.newCreditCardList) {
        // Review
        await this.reviewCardList()
      }
    },
    async reviewCardList() {
      const apiURI = this.$store.state.promotionManagement.menu.creditCardListGet
      if (apiURI) {
        try {
          const expand = {
            cardListCode: this.cardListCode
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Promotion init
            this.cardListForm.cardListCode = data.crCdList.cardListCode
            this.cardListForm.cardListDesc = data.crCdList.cardListDesc
            this.items = data.crCdList.cardNoList
            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doCloseCardDialog() {
      this.cardNoDialog = false
      this.newCardNo = false
      this.cardForm.cardNo = undefined
      this.cardForm.cardDesc = undefined
    },
    doNew() {
      this.resetValidator()
      this.cardNoDialog = true
      this.newCardNo = true
      this.cardForm.cardNo = undefined
      this.cardForm.cardDesc = undefined
    },
    doReview(data) {
      this.resetValidator()
      this.cardNoDialog = true
      this.newCardNo = false
      this.cardNoIndex = data.index
      this.cardForm.cardNo = data.item.cardNo
      this.cardForm.cardDesc = data.item.cardDesc
    },
    doSaveCard() {
      this.resetMessages()
      this.$validator.validateAll('cardForm').then(result => {
        if (result) {
          if (this.newCardNo) {
            this.doNewCard()
          } else {
            this.doEditCard()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNewCard() {
      const result = this.items.find(x => x.cardNo === this.cardForm.cardNo)
      if (result) {
        this.errorMessage('Duplicate Card No. was found.')
      } else {
        this.items.push({
          cardNo: this.cardForm.cardNo.trim(),
          cardDesc: this.cardForm.cardDesc.trim()
        })
        this.cardNoDialog = false
      }
    },
    doEditCard() {
      const pushObj = {
        cardNo: this.cardForm.cardNo.trim(),
        cardDesc: this.cardForm.cardDesc.trim()
      }
      Object.assign(this.items[this.cardNoIndex], pushObj)
      this.cardNoDialog = false
    },
    doRemove(data) {
      this.items.splice(data.index, 1)
    },
    doSaveCardList() {
      this.resetMessages()
      this.$validator.validateAll('cardListForm').then(result => {
        if (result) {
          if (this.newCreditCardList) {
            this.doCreateCardList()
          } else {
            this.doUpdateCardList()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateCardList() {
      const apiURI = this.$store.state.promotionManagement.menu.creditCardListCreate
      if (apiURI) {
        this.submitting = true
        try {
          const submitForm = {
            cardListCode: this.cardListForm.cardListCode,
            cardListDesc: this.cardListForm.cardListDesc,
            cardNoList: this.items
          }
          const result = await this.$http.post(apiURI, submitForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'creditCardLists' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doUpdateCardList() {
      const apiURI = this.menu.update
      if (apiURI) {
        this.submitting = true
        try {
          const submitForm = {
            cardListCode: this.cardListForm.cardListCode,
            cardListDesc: this.cardListForm.cardListDesc,
            cardNoList: this.items
          }
          const result = await this.$http.put(apiURI, submitForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'creditCardLists' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doQuery() {
      this.$router.push({ name: 'creditCardListQuery', params: { cardListCode: this.cardListCode } })
    }
  },
  mounted() {
    this.breadcrumb = this.derieveBreadcrumbByName('creditCardLists')
    this.breadcrumb.push({
      name: 'creditCardListReview',
      text: this.title
    })
    if (this.cardListCode === 'new') {
      this.loading = false
    }
  },
  created() {
    if (this.cardListCode === 'new') {
      this.newCreditCardList = true
    } else {
      this.doInit()
    }
  },
  props: {
    cardListCode: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
